import { RowSelectionOptions } from "ag-grid-community/dist/types/src/entities/gridOptions";
import { ColDef } from "ag-grid-community";

export const opportunitiesGridWrapperStyles = {
  ".ag-cell-wrapper": { width: "100%", height: "100%", alignItems: "center" },

  ".ag-pinned-right-cols-container": {
    boxShadow: "-2px -10px 15px 0px rgba(0,0,0,25%)",
  },
  ".ag-pinned-right-header": {
    boxShadow: "-2px 0px 15px 0px rgba(0,0,0,25%)",
  },
};

export const opportunitiesGridRowSelection: RowSelectionOptions = {
  mode: "multiRow",
  selectAll: "filtered",
  hideDisabledCheckboxes: true,
  checkboxLocation: "autoGroupColumn",
  groupSelects: "filteredDescendants",
  isRowSelectable: (row) => !row.group,
};

export const opportunitiesGridDefaultColumnDef: ColDef = {
  minWidth: 150,
  unSortIcon: true,
  enableRowGroup: true,
  filter: "agMultiColumnFilter",
  cellStyle: ({ node }) => (!node.group ? { cursor: "pointer" } : undefined),
  loadingCellRenderer: () => (
    <div className="p-2 animate-pulse bg-gray-200 rounded-md w-full h-4">
      --------------------------------
    </div>
  ),
};
